import classNames from 'classnames/bind'
import moment from 'moment'

import parseDurationTime from '../../../utils/parseDurationTime'

const frenchPriceParse = price => price.replace(/\./g, ',')


const currentQuarter = moment().quarter()

export default ({ products, subscription, setSubscription, t, language }) => (
  <ul className="subscription">
    {
      products.map(product => (
        product.is_active && (
          <li key={product.id}>
            <span className={classNames({
                'subscription-item': true,
                'active': subscription.id === product.id
              })}
              onClick={() => setSubscription(product)}>
              { product.quarter_price ? (
                language === 'en'
                  ? `$${product.quarter_price[currentQuarter - 1]} - ${t('common:account_page-ids-subscription')}`
                  : `${frenchPriceParse(product.quarter_price[currentQuarter - 1])} $ - ${t('common:account_page-ids-subscription')}`
              ) : (
                language === 'en'
                  ? `$${product.price} - ${parseDurationTime(product.duration_days, t)}`
                  : `${frenchPriceParse(product.price)} $ - ${parseDurationTime(product.duration_days, t)}`
              ) }
            </span>
          </li>
        )
      ))
    }
  </ul>
)



// WEBPACK FOOTER //
// ./components/SubscriptionsSelector/SubscriptionsList/index.js